import React, { useState } from "react";
import cogoToast from "cogo-toast";

const ART = process.env.PUBLIC_URL + "/assets/img/home/newsletter-envelope.png";

/*
 * Newsletter subscribe banner. There is no newsletter backend endpoint yet,
 * so submitting validates the email and confirms locally. Wire handleSubmit()
 * to the real mailing-list endpoint when it exists.
 */
const NewsletterBar = () => {
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email) return;
    cogoToast.success("Thanks for subscribing!", { position: "top-right" });
    setEmail("");
  };

  return (
    <div className="c4home">
      <div className="c4wide">
        <section className="c4news" aria-labelledby="c4news-heading">
          <div className="c4news__banner">
            <div className="c4news__art">
              <img src={ART} alt="" />
            </div>
            <div className="c4news__body">
              <p className="c4news__eyebrow">Subscribe to Our Newsletter</p>
              <h2 className="c4news__title" id="c4news-heading">
                Stay Connected to <span>Sustainable Living</span>
              </h2>
              <p className="c4news__text">
                Get the latest eco-friendly products, exclusive offers,
                sustainability tips, and handcrafted collections delivered
                straight to your inbox.
              </p>
              <form className="c4news__form" onSubmit={handleSubmit}>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email address"
                  aria-label="Email address"
                  required
                />
                <button type="submit">
                  Subscribe Now
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M22 2 11 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M22 2 15 22l-4-9-9-4 20-7Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
              </form>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default NewsletterBar;
